import React from 'react';

import { Container } from './styles';

const Typing: React.FC = () => {
  return (
    <Container>
      <span />
      <span />
      <span />
    </Container>
  );
};

export default Typing;
